export default __webpack_public_path__ + "static/media/f03.d72e2069.svg";